module.exports = __webpack_public_path__ + "static/media/girl-24.98fb92a6.svg";